import React, { useCallback, useState } from 'react'
import Button from 'components/ui/button'
import Tooltip from 'components/ui/tooltip'
type ActionKind = 'import' | 'star'
type Props = {
  active: boolean | null | undefined
  onClick: () => any
  actionKind?: ActionKind
}

const getActionText = (
  actionKind: ActionKind,
  active: boolean | null | undefined,
) => {
  if (actionKind === 'import') {
    return 'Import to Starred items'
  }

  return active ? 'Remove from Starred items' : 'Add to Starred items'
}

/**
 * A star/import action button component with loading state and tooltip
 * @param active - Whether the item is currently starred/active
 * @param onClick - Callback function to handle star/import action
 * @param actionKind - Type of action - either 'star' or 'import'
 */
const ActionStar = ({ active, onClick, actionKind = 'star' }: Props) => {
  const [loading, setLoading] = useState(false)
  const onClickHandler = useCallback(async () => {
    setLoading(true)
    const onClickResult = onClick()

    // If onClick returns a Promise, await it
    if (onClickResult instanceof Promise) {
      await onClickResult
    }

    setLoading(false)
  }, [onClick])
  return (
    <Tooltip content={getActionText(actionKind, active)}>
      <Button
        appearance="icon"
        compact
        icon={active ? 'star' : 'starred'}
        onClick={onClickHandler}
        disabled={loading}
      />
    </Tooltip>
  )
}

export default React.memo<Props>(ActionStar)
